// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2c1739bb","453":"b03e3c98","455":"d4791770"}[chunkId] + ".chunk.js";
};